const languages = ['ru', 'en', 'de', 'es', 'it', 'fr', 'pl', 'cs', 'hu', 'ro'];
const langFields  = {
  'category-{lang}_name': 'Категория({lang})',
  'characteristic-{lang}': 'Характеристика({lang})',
  'type-{lang}': 'Тип({lang})',
  'description-{lang}': 'Описание({lang})',
  'short_description-{lang}': 'Краткое описание({lang})',
  'orderDescriptions-{lang}': 'Рандомное описание({lang})',
  'uniqueDescriptions-{lang}': 'Уник. описание({lang})',
  'uniqueCharacteristics-{lang}': 'Уник. характеристики({lang})'
};
const fields  = {};

for (const [key, value] of Object.entries(langFields)) {
  languages.forEach(l=>{
    let langKey = key.replace('{lang}', l)
    let langValue = value.replace('{lang}', l)
    fields[langKey] = langValue
  })
}

export default {
  id: 'Id товара',
  name: 'Название',
  articleAlias: 'Артикль',
  brand: 'Бренд',
  pdfs_1: 'Документ 1',
  pdfs_2: 'Документ 2',
  pdfs_3: 'Документ 3',
  pdfs_4: 'Документ 4',
  photos: 'Картинки',
  category: 'Категория',
  'category-id': 'ID Категории',
  parentName: 'Родитель',
  parentStatus: 'Статус родства',
  seoFlag: 'SEO флаг',
  'siteModels-modelId': 'id модели с сайта',
  siteArticleId: 'id артикула c сайта',
  characteristic: 'Характеристика',
  weight: ' Вес в граммах',
  template_description: 'Шаблонное описание',
  dimension: 'Размерность(значение)',
  dimension_type: 'Размерность(тип)',
  description: 'Описание',
  donor_name: 'Донор:название',
  donor_link: 'Донор:ссылка',
  type: 'Тип',
  link: 'Ссылка на товар',
  tags: 'Теги',
  search_query: 'Поисковый запрос',
  price: 'Цена закупки (Евро)',
  priceMin: 'Мин. цена',
  priceRu: 'Цена (ru)',
  priceRuMin: 'Мин. цена (ru)',
  currency: 'Валюта(EUR)',
  customs_number: 'Таможенного номера',
  EAN: 'EAN',
  additional_1: 'Статус производства',
  additional_2: 'id товара-замены',
  additional_3: 'Срок поставки с чужого склада',
  additional_4: 'Цена конкурентов',
  additional_5: 'Цена последнего запроса (Евро)',
  additional_6: 'Дата цены запроса',
  additional_7: 'Складская позиция',
  additional_8: 'Приблизительный вес',
  additional_9: 'Маржинальность',
  additional_10: 'Срок поставки',
  old_article: 'Старый артикул',
  short_description: 'Краткое описание',
  garbage_1: 'Помойка1',
  garbage_2: 'Помойка2',
  uniqueCharacteristics: 'Уник. характеристики',
  is_online: 'Online',
  is_shop: 'Shop',
  availabilityDe: 'Свой склад',
  availabilityRu: 'Склад поставщика',
  isPublished: 'Опубликован',
  updated_date: 'Обновление',
  'brand-name': 'Бренд',
  article: 'Артикль',
  'parent-name': 'Родитель',
  'parentStatus-name': 'Статус родства',
  'photos-location': 'Картинки',
  searchQuery: 'Поисковый запрос',
  lastOrderDate: 'Дата последнего заказа',
  isOnline: 'Online',
  isShop: 'Shop',
  'orderDescriptions-und': 'Рандомное описание(und)',
  plannedArrivalFromDe: 'Срок поставки мин. (de)',
  plannedArrivalToDe: 'Срок поставки макс. (de)',
  plannedArrivalFromRu: 'Срок поставки мин. (ru)',
  plannedArrivalToRu: 'Срок поставки макс. (ru)',
  'marketplace-price': 'Marketplace Price',
  'marketplace-stock': 'Marketplace Stock',
  'marketplace-min_order_quantity': 'Marketplace Minimum Order Quantity',
  'marketplace-order_quantity_step': 'Marketplace Order Quantity Step',
  'marketplace-units_per_package': 'Marketplace Units Per Package',
  'marketplace-category_path': 'Marketplace Categories',
  'marketplace-product_title': 'Marketplace Product Title',
  ...fields
}